import React from 'react';
import { stats, steps } from '../mock';
import { Video, Users, BookOpen, Sparkles } from 'lucide-react';

const iconMap = { Video, Users, BookOpen, Sparkles };

const Features = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={i}
                className="group p-8 rounded-3xl bg-[#faf7f1] hover:bg-[#3a5a2c] hover:text-white transition-all duration-500 cursor-default border border-transparent hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-2xl bg-white group-hover:bg-white/10 flex items-center justify-center mb-6 transition">
                  <Icon className="w-5 h-5 text-[#3a5a2c] group-hover:text-white transition" />
                </div>
                <h3 className="font-serif text-xl text-[#1a2b17] group-hover:text-white mb-3 transition">
                  {s.title}
                </h3>
                <p className="text-sm text-[#4a5544] group-hover:text-white/80 leading-relaxed transition">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>

        {/* How it Works */}
        <div className="mt-28">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-4">
            <div>
              <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Our Process</div>
              <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] tracking-tight">
                How it works
              </h2>
            </div>
            <p className="text-[#4a5544] max-w-md">
              Three simple steps between where you are and where you want to be —
              zero pressure, all clarity.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {steps.map((s, i) => (
              <div
                key={s.num}
                className="relative p-10 rounded-3xl bg-[#faf7f1] hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="font-serif text-7xl text-[#3a5a2c]/10 leading-none absolute top-6 right-8">
                  {s.num}
                </div>
                <div className="w-10 h-10 rounded-full bg-[#3a5a2c] text-white flex items-center justify-center font-medium text-sm mb-6 relative">
                  {s.num}
                </div>
                <h3 className="font-serif text-2xl text-[#1a2b17] mb-3 relative">
                  {s.title}
                </h3>
                <p className="text-[#4a5544] leading-relaxed text-sm relative">
                  {s.desc}
                </p>
                {i < steps.length - 1 && (
                  <div className="hidden md:block absolute -right-3 top-1/2 w-6 h-px bg-[#3a5a2c]/30 z-10" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
